/* eslint-disable unicorn/filename-case -- TODO rename later */
import { User } from "@istari/istari-client";

import { LabeledControlTag } from "~/api/useControlTags";
import { InternalUserType } from "~/api/user/user";

export function userToInternalUser(user: User): InternalUserType {
  return {
    ...user,
    controlTags: user.controlTags?.map((tag) => ({
      ...tag,
      color: tag.displayColor,
      label: tag.name,
      value: tag.id,
    })) as LabeledControlTag[],
    fullName: `${user.firstName} ${user.lastName}`,
    label: `${user.firstName} ${user.lastName}`,
    value: user.id,
  };
}
